import PageHeadline from './PageHeadline';

export default PageHeadline;
